import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import styles from '../styles/userEligibilityForm.module.scss';

/**
 * Read-only callout rendered inside `ServiceAccessCard` for modes that
 * don't expose any control of their own (`OPEN`, `DISABLED`). Surfaces
 * the corresponding `MODE_DESCRIPTIONS` entry as a soft dashed-bordered
 * notice so the user understands why the panel has nothing to configure.
 */
function NoticePanel({ description }) {
    return (
        <div className={styles.notice}>
            <Text as="span" size="s" className={styles.noticeText}>
                {description}
            </Text>
        </div>
    );
}

export default NoticePanel;
